import { Component, OnInit } from '@angular/core';
import { FinancialParameterService } from 'src/app/services/financial-parameter.service';
import { GetFinancialParameter } from 'src/app/models/financial-parameter/get';
import { AddFinancialParameter } from 'src/app/models/financial-parameter/add';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FinancialParameterModalComponent } from './modal/financial-parameter-modal.component';

@Component({
  selector: 'app-financial-parameter',
  templateUrl: './financial-parameter.component.html',
  styleUrls: ['./financial-parameter.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
  FinancialParameterModalComponent
  ],
})
export class FinancialParameterComponent implements OnInit {

  parameters: GetFinancialParameter[] = [];
  paginated: GetFinancialParameter[] = [];
  page = 1;
  pageSize = 5;

  showModal = false;
  selectedParam?: GetFinancialParameter;
  newValue: number | null = null;
  errorMessage: string = '';

  typeNames: { [key: number]: string } = {
    1: 'Monto',
    2: 'Porcentaje',
    3: 'Otro'
    // Agrega aquí los tipos que necesites
  };

  constructor(private _service: FinancialParameterService) {}

  ngOnInit(): void {
    this.loadParameters();
  }

  loadParameters(): void {
    this._service.getAll().subscribe({
      next: (res) => {
        this.parameters = res;
        this.setPage(1);
      },
      error: () => alert("No se pudieron cargar los parámetros")
    });
  }

  setPage(page: number): void {
    this.page = page;
    const start = (page - 1) * this.pageSize;
    const end = start + this.pageSize;
    this.paginated = this.parameters.slice(start, end);
  }

  openModal(param: GetFinancialParameter): void {
    this.selectedParam = param;
    this.newValue = param.value;
  this.errorMessage = '';
    this.showModal = true;
  }

  closeModal(): void {
    this.showModal = false;
    this.selectedParam = undefined;
    this.newValue = null;
  this.errorMessage = '';
  }

  save(): void {
    if (this.selectedParam == null || this.newValue == null) return;

    const newVal = Number(this.newValue);
    const oldVal = Number(this.selectedParam.value);

    if (isNaN(newVal)) {
      this.errorMessage = "El valor ingresado no es válido.";
      return;
    }

    if (newVal === oldVal) {
      this.errorMessage = "El nuevo valor debe ser diferente al actual.";
      return;
    }
    if (newVal < 0) {
      this.errorMessage = "No se permiten valores negativos.";
      return;
    }

    if (!confirm(`¿Confirmas que deseas actualizar el valor de ${this.selectedParam.code}?`)) {
      return;
    }

    const payload: AddFinancialParameter = {
      code: this.selectedParam.code,
      value: newVal,
      type: this.selectedParam.type
    };

    this._service.add(payload).subscribe({
      next: () => {
        alert("Parámetro actualizado correctamente.");
        this.closeModal();
        this.loadParameters();
      },
      error: (err) => {
        alert("Error al actualizar: " + err.error);
      }
    });
  }

  getTypeName(type: number): string {
    return this.typeNames[type] || 'Desconocido';
  }
}
